import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { AdminPickSummary } from "../../models/AdminModels";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";

export const AdminPickCounts = () => {
  const pickCountWidth = 150;
  const [pickSummaries, setPickSummaries] = useState<AdminPickSummary[]>([]);

  useEffect(() => {
    //TODO:DF Local loading indicator
    axios.get<{picks: AdminPickSummary[]}>(`${process.env.REACT_APP_API_URL}/admin/yearStatus`).then((r) => {
      setPickSummaries(r.data.picks);
    });
  }, []);

  const columns: GridColDef[] = [
    { field: "name", headerName: "", width: 150 },
    {
      field: "teamName",
      headerName: "Team Name",
      width: 150,
      editable: false,
    },
    {
      field: "round1PickCount",
      headerName: "Round 1",
      type: "number",
      width: pickCountWidth,
      editable: false,
    },
    {
      field: "round2PickCount",
      headerName: "Round 2",
      type: "number",
      width: pickCountWidth,
      editable: false,
    },
    {
      field: "round3PickCount",
      headerName: "Round 3",
      type: "number",
      width: pickCountWidth,
      editable: false,
    },
    {
      field: "round4PickCount",
      headerName: "Cup Final",
      type: "number",
      width: pickCountWidth,
      editable: false,
    },
  ];

  return (
    <div>
      <Box>
        <DataGrid getRowId={(c) => c.userId} autoHeight rowHeight={30} hideFooter={true} rows={pickSummaries} columns={columns} disableRowSelectionOnClick />
      </Box>
    </div>
  );
};
